import { map } from 'rxjs';
import type { ObjectivesView, ObjectivesInput } from '../../../core/interfaces/backend/arboles_objetivos/arboles_objetivos.workflow.interface';
import type { SuccessEnvelope } from '../../../core/interfaces/http/response.interface';
import type { Envelope, Deleted } from '../../../core/interfaces/http/response.interface';
import type { SideData } from '../../../core/interfaces/http/pagination.interface';
import type { ArbolesObjetivosRead, ArbolesObjetivosCreate, ArbolesObjetivosReplace, ArbolesObjetivosPatch, ArbolesObjetivosIdentifier, ArbolesObjetivosDeleteAll } from '../../../core/interfaces/backend/arboles_objetivos/arboles_objetivos.interface';

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ArbolesObjetivos {
  private readonly http = inject(HttpClient);
  private readonly url = environment.backendUrl.replace(/\/$/, '') + '/pvt/gb/arboles_objetivos';
  sideQuery(page = 1, row = 20, sort: keyof ArbolesObjetivosRead = 'id_registro', direction: 'asc' | 'desc' = 'asc',
    filters: Partial<ArbolesObjetivosRead> = {}, headers?: HttpHeaders): Observable<HttpResponse<Envelope<SideData<ArbolesObjetivosRead>>>> {
    return this.http.get<Envelope<SideData<ArbolesObjetivosRead>>>(this.url + '/side/query', {
      observe: 'response', headers,
      params: { page, row, sort, direction, filters: JSON.stringify(filters) },
    });
  }
  selectAll(headers?: HttpHeaders): Observable<HttpResponse<Envelope<ArbolesObjetivosRead[]>>> {
    return this.http.get<Envelope<ArbolesObjetivosRead[]>>(this.url + '/select/all', {
      observe: 'response',
      headers,
    });
  }
  selectReg(
    id_registro: string,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<ArbolesObjetivosRead>>> {
    return this.http.get<Envelope<ArbolesObjetivosRead>>(this.url + '/select/reg', {
      observe: 'response',
      headers,
      params: { id_registro },
    });
  }
  selectPgt(
    sheet = 1,
    row = 20,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<ArbolesObjetivosRead[]>>> {
    return this.http.get<Envelope<ArbolesObjetivosRead[]>>(this.url + '/select/pgt', {
      observe: 'response',
      headers,
      params: { sheet, row },
    });
  }
  insertRegister(
    body: ArbolesObjetivosCreate,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<ArbolesObjetivosRead>>> {
    return this.http.post<Envelope<ArbolesObjetivosRead>>(this.url + '/insert/register', body, {
      observe: 'response',
      headers,
    });
  }
  insertMultiple(
    body: ArbolesObjetivosCreate[],
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<ArbolesObjetivosRead[]>>> {
    return this.http.post<Envelope<ArbolesObjetivosRead[]>>(this.url + '/insert/multiple', body, {
      observe: 'response',
      headers,
    });
  }
  replaceRegister(
    body: ArbolesObjetivosReplace,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<ArbolesObjetivosRead>>> {
    return this.http.put<Envelope<ArbolesObjetivosRead>>(this.url + '/update/register', body, {
      observe: 'response',
      headers,
    });
  }
  replaceMultiple(
    body: ArbolesObjetivosReplace[],
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<ArbolesObjetivosRead[]>>> {
    return this.http.put<Envelope<ArbolesObjetivosRead[]>>(this.url + '/update/multiple', body, {
      observe: 'response',
      headers,
    });
  }
  patchRegister(
    body: ArbolesObjetivosPatch,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<ArbolesObjetivosRead>>> {
    return this.http.patch<Envelope<ArbolesObjetivosRead>>(this.url + '/update/register', body, {
      observe: 'response',
      headers,
    });
  }
  patchMultiple(
    body: ArbolesObjetivosPatch[],
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<ArbolesObjetivosRead[]>>> {
    return this.http.patch<Envelope<ArbolesObjetivosRead[]>>(this.url + '/update/multiple', body, {
      observe: 'response',
      headers,
    });
  }
  deleteRegister(
    body: ArbolesObjetivosIdentifier,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<Deleted>>> {
    return this.http.delete<Envelope<Deleted>>(this.url + '/delete/register', {
      observe: 'response',
      headers,
      body,
    });
  }
  deleteMultiple(
    body: ArbolesObjetivosIdentifier[],
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<Deleted>>> {
    return this.http.delete<Envelope<Deleted>>(this.url + '/delete/multiple', {
      observe: 'response',
      headers,
      body,
    });
  }
  deleteAll(
    body: ArbolesObjetivosDeleteAll,
    headers?: HttpHeaders,
  ): Observable<HttpResponse<Envelope<Deleted>>> {
    return this.http.delete<Envelope<Deleted>>(this.url + '/delete/all', {
      observe: 'response',
      headers,
      body,
    });
  }

  viewProject(projectId:string) {
    return this.http.get<SuccessEnvelope<ObjectivesView>>(this.url + '/project/' + projectId).pipe(map(r => r.data));
  }
  saveProject(projectId:string, body:ObjectivesInput) {
    return this.http.post<SuccessEnvelope<ObjectivesView>>(this.url + '/project/' + projectId, body).pipe(map(r => r.data));
  }
  downloadProjectFile(projectId:string, fileId:string) {
    return this.http.get(this.url + '/project/' + projectId + '/files/' + fileId, {responseType:'blob'});
  }
}
